import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  HazardTable,
} from './DocumentPage';

const OvergroundTankBasesDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Production of Bases for Overground Tanks – Risk Assessment"
    documentHeading="Risk Assessment 16: Production of Base Units for Overground Tanks"
    meta={[
      ['Document Reference', 'PVS-RA-16'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Area / Location', 'Pyrolysis Building'],
      ['Activity', 'Production of base units for the overground tank – mixing of materials and formation into moulds'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Production of Bases for Overground Tanks – Risk Assessment',
      documentReference: 'PVS-RA-16',
      processActivity: 'Production of Overground Tank Bases',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Scope">
      <Paragraph>
        This assessment covers the production of base units for overground tanks, including mixing
        of materials and the formation of these materials into moulds, within the Pyrolysis Building.
      </Paragraph>
    </Section>

    <Section number="2" title="Hazard Identification and Risk Assessment">
      <HazardTable
        columns={['Hazards', 'Control Measures Already in Place', 'Additional Control Measures Required']}
        rows={[
          [
            [
              'Manual handling injury as a result of loading the mixer or moving the finished bases.',
              'Contact with moving mixer arms potentially causing severe injury.',
              'Contact with chemical substances leading to skin burns, dermatitis and other physical health risks (e.g. respiratory).',
            ],
            [
              'Staff have been provided with sufficient information, instruction and training.',
              'Equipment is well maintained.',
              'Personal protective equipment (PPE) is provided and worn, for example safety footwear, protective gloves and face masks.',
              'Mechanical means of loading the mixer and moving the moulds is in place via the use of forklift trucks. Actual manual handling within the task is minimal.',
              'Physical guards prevent access to the moving mixer arms when the machine is in use.',
              'COSHH assessment completed on substances used.',
            ],
            'No additional measures required.',
          ],
        ]}
      />
    </Section>

    <Section number="3" title="Reminder">
      <Paragraph className="font-semibold">
        You have a duty not only to protect your own health and safety but also to ensure that your
        actions do not put others around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default OvergroundTankBasesDoc;
